import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';
import {
  insertCustomComponents,
} from './common';
import Utils from '../../utils';
import { Context } from '../context';

export default class PopupCustom extends CommonBlock {
  componentDidMount() {
    const body = document.getElementById(`WioGameBG_${this.props.campaignId}`);
    const contentBlock = body.querySelector('#wioContent');
    const buttonList = contentBlock.getElementsByTagName('button');
    for (let i = 0; i < buttonList.length; i += 1) {
      if (buttonList[i].id === 'wioRefuse') {
        buttonList[i].onclick = this.props.refuseBlock;
      } else {
        buttonList[i].onclick = this.props.customAction;
      }
    }
  }

  componentDidUpdate() {
    insertCustomComponents(this.props);

    if (localStorage.getItem('currentClosed') && Utils.getCampaignData(this.props.notifBell, false)) this.closeBlock();
  }

  getStyle = () => {
    const style = { padding: '10px' };
    if (Utils.getCampaignData(this.props.backgroundImg)) style.backgroundImage = `url('${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${Utils.getCampaignData(this.props.backgroundImg)}')`;
    if (Utils.getCampaignData(this.props.height)) style.maxHeight = Utils.getCampaignData(this.props.height);
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    if (Utils.getCampaignData(this.props.exitUrl)) style.cursor = 'pointer';
    const styleKey = ['backgroundColor', 'fontFamily', 'width', 'top', 'left', 'bottom', 'right'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    return style;
  };

  getExitStyle = () => {
    const exitStyle = {
      background: 'none', border: 'none', top: '0', right: '0', position: 'absolute', margin: '5px',
    };
    if (Utils.getCampaignData(this.props.exitButtonColor)) exitStyle.background = this.props.exitButtonColor.value;
    if (Utils.getCampaignData(this.props.exitButtonFontColor)) exitStyle.color = this.props.exitButtonFontColor.value;
    if (Utils.getCampaignData(this.props.fontFamily)) exitStyle.fontFamily = this.props.fontFamily.value;

    return exitStyle;
  };

  render() {
    let content = Utils.getCampaignData(this.props.content, '');
    content = content.replace('{{firstName}}', Context.customer.first_name);
    const modalStyle = {};
    if (Utils.getCampaignData(this.props.modalColor, '')) modalStyle.backgroundColor = Utils.getCampaignData(this.props.modalColor, '');
    const banClass = Utils.getCampaignData(this.props.emplacement) ? `Wio${Utils.getCampaignData(this.props.emplacement)}` : '';

    return (
      <div>
        <div
          id="wio_ban"
          style={this.getStyle()}
          className={`WioFloat ${banClass} WioPopup`}
          onClick={() => {
            if (!Utils.getCampaignData(this.props.exitUrl)) return;

            window.location.href = Utils.getCampaignData(this.props.exitUrl);
          }}
        >
          <div
            id="wioContent"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          <button
            id="wioBlockExit"
            style={this.getExitStyle()}
            onClick={this.closeBlock}
          >
            X
          </button>
        </div>
        <div id="WioModal" className="WioModal" style={modalStyle} onClick={this.closeBlock} />
        {this.insertBellButton()}
      </div>
    );
  }
}
